export const USER_LOADING = 'auth/USER_LOADING'
export const USER_LOADED = 'auth/USER_LOADED'
export const AUTH_ERROR = 'auth/AUTH_ERROR'
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS'
export const LOGIN_FAIL = 'auth/LOGIN_FAIL'
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS'
